/* eslint-disable no-restricted-imports */
import React, { useEffect, useState, useCallback } from "react";
import { Button } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";
import DatePicker from "react-datepicker";
import * as moment from "moment";
import { getDashboardData } from "../modules/Auth/_redux/dashboardCrud";
import { toAbsoluteUrl } from "../../_metronic/_helpers";

export function InMailPage() {
  const useStyles = makeStyles(theme => ({
    inputStyle: {
      display: "inline-flex",
      width: "200px",
      height: "32px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      borderRadius: "4px 4px 4px 4px",
    //   ":active": {
    //     border: "1px solid #c8cace"
    //   }
    },
    buttonStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1.2rem",
      marginRight: "12px"
    },
    buttonClearStyle: {
      width: "32px",
      height: "32px",
      border: "0px solid #123456",
      marginRight: "12px",
      "&:hover": {
        backgroundColor: "transparent !important"
      }
    },
    searchStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem",
      float: "right"
    },
    dateStyle: {
      width: "160px",
      height: "32px",
      color: "#123456",
      border: "1px solid #c8cace",
      fontSize: "1rem",
      marginRight: "36px",
      textAlign: "left",
      background: "transparent",
      borderRadius: "4px 4px 4px 4px",
      paddingLeft: "12px"
    },

    boxContainer: {
      display: "inline-block",
      width: "100%",
      verticalAlign: "top"
    },
    box30Style: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    boxStyle: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    subTitleStyle: {
      display: "flex",
      fontSize: "1.2rem",
      marginBottom: "12px",
      fontWeight: "bold",
      color: "#555555"
    },
    subTitleLastStyle: {
      fontSize: "1.2rem",
      fontWeight: "bold",
      color: "#555555",
      marginTop: "-8px"
    },
    headerRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px"
    },
    headerColStyle: {
      display: "inline-block",
      fontSize: "1rem",
      textAlign: "center",
      width: "50%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCol20Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "20%",
      background: "#dfe2e8",
      height: "44px"
    },
    dataRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px",
      borderBottom: "1px solid lightgray"
    },
    dataCol100Style: {
      display: "inline-block",
      fontSize: "1rem",
      textAlign: "left",
      width: "100%",
      height: "44px"
    },
    dataCol20Style: {
      display: "inline-block",
      fontSize: "1rem",
      textAlign: "left",
      width: "20%",
      height: "44px"
    },
    dataColStyle: {
      display: "inline-block",
      fontSize: "1rem",
      textAlign: "center",
      width: "50%",
      height: "44px"
    },
    dataColSmallStyle: {
      display: "inline-block",
      fontSize: "12px",
      textAlign: "center",
      width: "50%",
      height: "44px",
      overflow: "hidden",
      lineHeight: "16px",
      paddingTop: "6px"
    },
    dataColTextStyle: {
      display: "inline-block",
      fontSize: "1rem",
      textAlign: "left",
      //   width: "50%",
      height: "44px"
    },
    radioStyle: {
      width: "80px",
      fontSize: "1rem",
      //   background: "transparent",
      color: "#555555",
      borderColor: "#dfe2e8",
      //   paddingTop: "6px",
      //   "&:hover": {
      //     color: "#123456",
      //     backgroundColor: "#eae4f5 !important"
      //   },
      "&:active": {
        color: "white",
        backgroundColor: "#123456 !important"
      }
    },
    selected: {
      color: "white",
      backgroundColor: "#123456 !important"
    }
  }));

  const [mailList, setMailList] = useState([
    {
      subject: "메일 제목입니다.",
      from: "홍길동 <gdhong@brainary.io>",
      to: "테스트 <jdev@naver.com>",
      date: "2021-10-23",
      server: "2.2.2."
    },
    {
      subject: "메일 제목입니다.",
      from: "홍길동 <gdhong@brainary.io>",
      to: "테스트 <jdev@naver.com>",
      date: "2021-10-23",
      server: "2.2.2."
    },
    {
      subject: "메일 제목입니다.",
      from: "홍길동 <gdhong@brainary.io>",
      to: "테스트 <jdev@naver.com>",
      date: "2021-10-23",
      server: "2.2.2."
    },
    {
      subject: "메일 제목입니다.",
      from: "홍길동 <gdhong@brainary.io>",
      to: "테스트 <jdev@naver.com>",
      date: "2021-10-23",
      server: "2.2.2."
    },
    {
      subject: "메일 제목입니다.",
      from: "홍길동 <gdhong@brainary.io>",
      to: "테스트 <jdev@naver.com>",
      date: "2021-10-23",
      server: "2.2.2."
    }
  ]);

  const Styles = useStyles();

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [from, setFrom] = React.useState("");
  const [server, setServer] = React.useState("");

  const CustomDateInput = ({ value, onClick }) => (
    <>
      <button className={Styles.dateStyle} onClick={onClick}>
        {value}
      </button>
      <img
        src={toAbsoluteUrl("/media/images/btn_schedule.svg")}
        style={{
          marginLeft: "-68px"
        }}
        alt=""
      />
    </>
  );

  const initDates = () => {
    const now = new Date();

    setStartDate(
      moment(now)
        .add(-7, "days")
        .toDate()
    );
    setEndDate(now);
  };

  const searchStats = () => {
    console.log(
      moment(startDate).format("YYYY-MM-DD"),
      moment(endDate).format("YYYY-MM-DD")
    );
  };

  useEffect(() => {
    initDates();
  }, []);

  useEffect(() => {}, []);

  return (
    <>
      <div
        style={{
          marginTop: "12px",
          marginLeft: "-12px",
          height: "100%"
        }}
      >
        {/* -------------------- */}

        <div className={Styles.boxContainer}>
          <div className={Styles.boxStyle}>
            <div className={Styles.subTitleStyle}>
              <Button className={Styles.buttonStyle} onClick={() => {}}>
                다운로드
              </Button>
            </div>
            <div className={Styles.subTitleStyle}>
              <DatePicker
                selected={startDate}
                dateFormat="yyyy/MM/dd"
                onChange={date => setStartDate(date)}
                customInput={<CustomDateInput />}
              />
              <span> &nbsp;&nbsp;&nbsp;~ &nbsp;&nbsp;&nbsp;</span>
              <DatePicker
                selected={endDate}
                dateFormat="yyyy/MM/dd"
                onChange={date => setEndDate(date)}
                customInput={<CustomDateInput />}
              />

              <div>
                <div
                  style={{
                    display: "inline-flex",
                    fontSize: "1rem",
                    fontWeight: "normal",
                    marginLeft: "24px",
                    marginRight: "12px"
                  }}
                >
                  받는사람
                </div>
                <input
                  type="text"
                  value={from}
                  style={{fontSize: '1rem'}}
                  className={Styles.inputStyle}
                  onChange={e => {
                    console.log("IP", e.target.value);
                    setFrom(e.target.value);
                  }}
                ></input>
              </div>
              <div>
                <div
                  style={{
                    display: "inline-flex",
                    fontSize: "1rem",
                    fontWeight: "normal",
                    marginLeft: "24px",
                    marginRight: "12px"
                  }}
                >
                  발송서버
                </div>
                <input
                  type="text"
                  value={server}
                  style={{fontSize: '1rem'}}
                  className={Styles.inputStyle}
                  onChange={e => {
                    console.log("DESC", e.target.value);
                    setServer(e.target.value);
                  }}
                ></input>
              </div>

              <span>&nbsp;&nbsp;&nbsp;</span>

              <Button className={Styles.searchStyle} onClick={searchStats}>
                조회
              </Button>
            </div>

            <div className={Styles.headerRowStyle}>
              <div className={Styles.headerCol100Style}>제목</div>
              <div className={Styles.headerColStyle}>보낸사람</div>
              <div className={Styles.headerColStyle}>받는사람</div>
              <div className={Styles.headerCol20Style}>날짜</div>
              <div className={Styles.headerCol20Style}>발송서버</div>
            </div>

            {mailList.map((mail, index) => (
              <div className={Styles.dataRowStyle}>
                <div className={Styles.dataCol100Style}>{mail.subject}</div>
                <div className={Styles.dataColStyle}>{mail.from}</div>
                <div className={Styles.dataColStyle}>{mail.to}</div>
                <div
                  className={Styles.dataCol20Style}
                  style={{ textAlign: "center" }}
                >
                  {mail.date}
                </div>
                <div
                  className={Styles.dataCol20Style}
                  style={{ textAlign: "center" }}
                >
                  {mail.server + index}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
